import { format, parseISO } from "date-fns";
import moment from "moment";
import { BlobServiceClient } from "@azure/storage-blob";
import { Paging } from "app/types";
const { REACT_APP_BLOB_SERVICE_CLIENT_URL } = process.env;

export const formattedDisplayDate = (dateStr: any) => {
  let d = new Date(dateStr);
  let newFormat = format(d, "d, MMM");
  return newFormat;
};

export const dateDisplayYear = (dateStr: any) => {
  let d = parseISO(dateStr);
  let newFormat = format(d, "d, MMM yy");
  return newFormat;
};

export const dateToStrFormat = (date: Date, type = 1) => {
  return type === 2
    ? `${format(date, "dd MMM, yyyy")}`
    : `${format(date, "yyyy-MM-dd")}`;
};

export const rangeDate = (start: Date, end: Date) => {
  for (
    var a = [], d = new Date(start);
    d <= new Date(end);
    d.setDate(d.getDate() + 1)
  ) {
    a.push(new Date(d));
  }
  return a;
};

export const removeEmpty = (obj: any) => {
  return Object.entries(obj)
    .filter(([_, v]) => v)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
};

export const strDateToObj = (date: string) => {
  return new Date(date);
};

export const getDayStringFromDate = (date: Date) => {
  const dayString = date.toLocaleDateString("en-US", { weekday: "long" }); // returns the full name of the day, e.g. "Monday"
  return dayString;
};

export const randomKeyObject = (obj: any) => {
  // Get all the keys and values as an array
  const entries = Object.entries(obj);

  // Combine keys and values into a single string
  const str = entries.reduce((acc, [key, value]) => acc + key + value, "");

  // Generate a random string based on the combined string
  const randomStr = Math.random().toString(36).substring(2) + str;

  return randomStr;
};

export const numberRoundOf = (number: any, decimal?: number) =>
  Number(number.toFixed(decimal || 3));

export const generateCSVHeaderFromTable = (column: any) => {
  const newList = column
    .filter((obj: any) => !(obj.options && obj.options.display === false))
    .map((obj: any) => ({ key: obj.name, label: obj.label }));

  return newList;
};

export const toLowCarbCase = (inputString: string) => {
  return inputString.charAt(0).toLowerCase() + inputString.slice(1);
};

export const formatNumber = (num: number) => {
  const nf = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return nf.format(num);
};
export const uploadImageToAzure = async (
  file: File,
  containerName: string,
  folderName: string,
  fileName?: string,
) => {
  try {
    const blobServiceClient = new BlobServiceClient(
      REACT_APP_BLOB_SERVICE_CLIENT_URL,
    );
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Months are zero-indexed, so we add 1
    const day = currentDate.getDate();

    const name = fileName || `${year}/${month}/${day}/${file.name}`;
    const blockBlobClient = containerClient.getBlockBlobClient(
      `${folderName}/${name}`,
    );
    await blockBlobClient.uploadData(file);
    return blockBlobClient.url;
  } catch (error) {
    console.error("Azure upload failed", error);
    throw error;
  }
};
export const formatDate = (dateString: string, format = "D, MMM h:mm A") => {
  return moment(dateString).format(format);
};
export const paginationDataConversion = (
  pagingData: Paging,
): {
  next: number;
  prev: number;
  total: number;
  currentPage: number;
} => {
  let next = null;
  let prev = null;
  let currentPage = 1;
  let total = 0;

  if (pagingData) {
    const paging = pagingData;
    total = paging.totalRecords;
    currentPage = paging.currentPage;
    const pageSize = paging.pageSize;

    const availableNoPages = Math.ceil(total / pageSize);

    // for next page
    if (currentPage < availableNoPages) {
      next = currentPage + 1;
    }

    // for previous page
    if (currentPage > 1) {
      prev = currentPage - 1;
    }
  }

  return { next, prev, total, currentPage };
};

export const formatNumberWithCommas = (num = 0) => {
  return Math.round(num * 100) / 100;
};
